export default __webpack_public_path__ + "static/media/project-discotheque.9f57bfc6.svg";